module.exports = __webpack_public_path__ + "static/media/router.6e19e3ca.svg";